import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import moment from 'moment';
import { BranchConstants } from '../constants';
import { MediaType } from '../constants/messageEvent';
import { AccountType, ChatRoomRawType, ChatRoomStatus } from '../types';
export function getComputedDateString(unixTimestamp) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'zh-tw';

  if (unixTimestamp === undefined || unixTimestamp === 0) {
    return '';
  }

  var oneDayBefore = moment().subtract(1, 'days');
  var twoDayBefore = moment().subtract(2, 'days');
  var oneWeekBefore = moment().subtract(7, 'days');
  var localDate = moment.unix(unixTimestamp);

  if (moment(localDate).isSameOrBefore(oneWeekBefore, 'day')) {
    return localDate.format('YYYY-MM-DD');
  } else if (moment(localDate).isSameOrBefore(twoDayBefore, 'day')) {
    return localDate.locale(locale.toLowerCase()).format('dddd');
  } else if (moment(localDate).isSameOrBefore(oneDayBefore, 'day')) {
    return '昨天';
  }

  return localDate.format('HH:mm');
}
export function sortChatRoomsData(a, b) {
  if (!!a.pinned && !b.pinned) {
    return -1;
  }

  if (!a.pinned && !!b.pinned) {
    return 1;
  }

  if (!!a.date && !b.date) {
    return -1;
  }

  return b.date - a.date;
}
export function mapChatRoomMember(item, locale) {
  return {
    avatarURL: (item === null || item === void 0 ? void 0 : item.avatar_thumbnail_url) || '/fallback-avatar.png',
    title: "".concat((item === null || item === void 0 ? void 0 : item.nick_name) || '', "\uFF08").concat((item === null || item === void 0 ? void 0 : item.name) || '', "\uFF09"),
    name: item === null || item === void 0 ? void 0 : item.name,
    nick_name: item === null || item === void 0 ? void 0 : item.nick_name,
    humanDateText: getComputedDateString(item.readAt, locale),
    id: String(item.id),
    isClient: (item === null || item === void 0 ? void 0 : item.class_name) === AccountType.client
  };
}
export function mapReadableTextFromMediaMessage(message, sender) {
  var mediaUrl = message.mediaUrl,
      mediaType = message.mediaType,
      text = message.text;
  var name = (sender === null || sender === void 0 ? void 0 : sender.nick_name) || (sender === null || sender === void 0 ? void 0 : sender.name) || '';
  var media = mediaType === MediaType.image ? '圖片' : mediaType === MediaType.video ? '影片' : '';
  var newText = text || (!!mediaUrl && !!media ? name ? "".concat(name, "\u5DF2\u50B3\u9001").concat(media) : "".concat(media, "\u5DF2\u50B3\u9001") : '');
  return _objectSpread(_objectSpread({}, message), {}, {
    text: newText
  });
}
export function mapChatroomFromHash(room, locale) {
  var _room$messages, _room$messages2, _room$unreadCount, _room$members;

  var lastMessage = room === null || room === void 0 ? void 0 : (_room$messages = room.messages) === null || _room$messages === void 0 ? void 0 : _room$messages[(room === null || room === void 0 ? void 0 : (_room$messages2 = room.messages) === null || _room$messages2 === void 0 ? void 0 : _room$messages2.length) - 1];
  var lastMessageSender = room === null || room === void 0 ? void 0 : room.members.find(function (member) {
    return member.gid === (lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.sender);
  });
  var isMedia = !!(lastMessage !== null && lastMessage !== void 0 && lastMessage.mediaType);
  var subTitle = isMedia ? mapReadableTextFromMediaMessage(lastMessage, lastMessageSender).text : "".concat(lastMessageSender ? "#".concat(lastMessageSender.id, ":") : '').concat((lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.text) || '');
  var roomName = room.code_name === ChatRoomRawType.personal && !BranchConstants.ENABLE_FORMAT_CHATROOM_NAME_ON_PERSONAL_ROOM ? room.name : room.display_name || room.name;
  return {
    id: String(room.chat_room_id),
    pinned: !!room.pinned,
    avatarURL: room.avatar_thumbnail_url || '/fallback-avatar.png',
    title: roomName || '',
    subTitle: subTitle,
    date: room.latest_message_at,
    // for sorting
    humanDateText: getComputedDateString(room.latest_message_at, locale),
    tag: room.unreadCount !== undefined && room.unreadCount > 0 ? room.unreadCount > 99 ? '99+' : ((_room$unreadCount = room.unreadCount) === null || _room$unreadCount === void 0 ? void 0 : _room$unreadCount.toString()) || '' : '',
    subItems: (_room$members = room.members) === null || _room$members === void 0 ? void 0 : _room$members.map(function (item) {
      return mapChatRoomMember(item, locale);
    }),
    textNote: room !== null && room !== void 0 && room.meMentioned ? '@ 您已被標註' : '',
    archived: (room === null || room === void 0 ? void 0 : room.status) === ChatRoomStatus.archived,
    _id: room.id,
    groupClass: room.group_class,
    type: room.type
  };
}